export type ReportLegacyConectionArgs = {
  name: string;
  email: string;
  reason: string;
  details: string;
  propertyId: number;
};

const reportLegacyConection = async ({
  name,
  email,
  reason,
  details,
  propertyId
}: ReportLegacyConectionArgs) => {
  await fetch(
    `${process.env.NEXT_PUBLIC_LEGACY_HOST}/sender.php?` +
      new URLSearchParams({
        type: 'reportar',
        pais: process.env.NEXT_PUBLIC_COUNTRY,
        id: String(propertyId),
        nombre: name,
        email,
        motivo: reason,
        mensaje: details
      }),
    {
      method: 'GET'
    }
  );
};

export default reportLegacyConection;
